import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class ContractorTypeService {

  constructor(
              private http: HttpClient,
              private global: GlobalDataService 
              ) {}

   getContractorTypeList() {
        return this.http.get(this.global.httpUrl+"contractors/types");
    }

   getContractorTypeById(id: any) {
        return this.http.get(this.global.httpUrl+"contractors/types/"+id);
    } 

   createContractorType(data: any){
        return this.http.post(this.global.httpUrl+"contractors/types", data); 
    }

   updateContractorType(data: any,id: any){
        return this.http.put(this.global.httpUrl+"contractors/types/"+id, data); 
    } 

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/contractor_types/contractor-type.service.ts